export default "<div class=\"explainer__feedback-answer\">\n    Thank you for your feedback.\n</div>";